// extracted by mini-css-extract-plugin
export default {"container":"Home_container__CrYAc","main_wrapper":"Home_main_wrapper__D0itC","main":"Home_main__Plxo2"};